import { render } from "./coinGeneral.vue?vue&type=template&id=3cd86ec1"
import script from "./coinGeneral.vue?vue&type=script&lang=js"
export * from "./coinGeneral.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__